import {
  GetCatalogProductViewQuery,
  CatalogVariantFragmentFragment,
} from '@notino/shared/definitions/types';

import { TrackingAttributes } from '@context/tracking/types';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';
import { resolveDrawerCloseType } from '@utils/drawer';

const trackDrawerEvent = (args: {
  timing: number;
  mode: string;
  interaction: string;
}) => {
  dispatchTrackingEvent({
    event: 'element_click',
    element: {
      mode: 'open',
      name: 'Drawer',
      interaction: 'click',
      action: '',
      promo_labels: undefined,
      type: 'drawer',
      ...args,
    },
    _clear: true,
  });
};

export const trackDrawerOpen = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    timing,
    interaction: 'click',
  });
};

export const trackDrawerClose = ({
  timing,
  closeType,
}: Omit<TrackingAttributes<{ closeType: string }>, 'variant'>) => {
  const eventLabel = resolveDrawerCloseType(closeType);

  trackDrawerEvent({
    mode: 'close',
    interaction: eventLabel,
    timing,
  });
};

export const trackResizeToTop = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    interaction: 'resize+',
    timing,
  });
};

export const trackResizeToMiddle = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: 'open',
    interaction: 'resize-',
    timing,
  });
};

export const trackDrawerVariantClick = ({
  timing,
}: Pick<TrackingAttributes, 'timing'>) => {
  trackDrawerEvent({
    mode: undefined,
    interaction: 'select_variant',
    timing,
  });
};

export const trackDrawerWatchdogClick = (
  product: GetCatalogProductViewQuery['productDetailByCatalogMasterId'],
  variant: CatalogVariantFragmentFragment
) => {
  dispatchTrackingEvent({
    event: 'watchdog_click',
    watchdog: {
      action: 'wt_add_watchdog',
      interaction: 'button',
      type: 'Drawer',
      products: [
        ProductEventWither()
          .withProduct(product)
          .withPartialVariant({
            ...variant,
            price: {
              __typename: 'Price',
              ...variant.price,
            },
            stockAvailability: {
              code: variant.stockAvailability.code,
              __typename: 'StockInfo',
            },
          })
          .build(),
      ],
    },
    _clear: true,
  });
};
